import { render, staticRenderFns } from "./index_kdr.vue?vue&type=template&id=3e8ae5de&scoped=true&"
import script from "./index_kdr.vue?vue&type=script&lang=js&"
export * from "./index_kdr.vue?vue&type=script&lang=js&"
import style0 from "./index_kdr.vue?vue&type=style&index=0&id=3e8ae5de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8ae5de",
  null
  
)

export default component.exports